import { useEffect, useState, useRef } from 'react';
import $ from 'jquery';
import DataTable from 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import { Row, Col, Accordion } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { byPrefixAndName } from '@awesome.me/kit-8685c875a9/icons'

const CurrentOrders = ({ orders }) => {
    const tableRef = useRef();
    useEffect(() => {
        if (!orders || orders.length === 0) return;

        const table = $(tableRef.current);

        if ($.fn.DataTable.isDataTable(table)) {
            table.DataTable().clear().destroy();
        }

        table.DataTable({
            dom: 'lfrtip',
            language: {
                lengthMenu: "Show _MENU_ orders per page",
                info: "Displaying _START_ to _END_ of _TOTAL_ results",
                search: "Search"
            }
        });

        // Cleanup on unmount
        return () => {
            if ($.fn.DataTable.isDataTable(table)) {
                table.DataTable().destroy();
            }
        };
    }, [orders]);
    return (
        <div className="currentOrders component">
            <Accordion defaultActiveKey="0"> {/* Ensures it's collapsed by default */}
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <Row>
                            <Col>
                                <h3>NRT Orders</h3>
                            </Col>
                        </Row>
                    </Accordion.Header>

                    <Accordion.Body>
                        <Row>
                            <Col xs={12}>
                                <table ref={tableRef} id="currentOrdersTable" className="table table-striped table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Order ID</th>
                                            <th>Order Info</th>
                                            <th>Notes</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orders.map((order, idx) => (
                                            <tr key={order.id || idx}>
                                                <td>{order.id}</td>
                                                <td>
                                                    <b>Client Name:</b> {order.clientProfile.firstName + " " + order.clientProfile.familyName}<hr />
                                                    <b>Order Created By:</b> {order.createdByName}<hr />
                                                    <b>Order Date:</b> {formatDate(order.dateCreated)}<hr />
                                                    <b>Products:</b> <br />{Array.isArray(order.products) &&
                                                        order.products.map((p, i) => (
                                                            <span key={i}>
                                                                {p.product.name}
                                                                <br />
                                                            </span>
                                                        ))}
                                                </td>
                                                <td>{order.notes}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    );
};

export default CurrentOrders;

const formatDate = (dateStr) => {
    if (!dateStr) return '';

    // Trim fractional seconds to 3 digits & ensure 'Z' (UTC)
    const normalised = dateStr.replace(/(\.\d{3})\d+$/, "$1") + "Z";

    const date = new Date(normalised);

    return date.toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, // local machine tz
    });
};



